/**
 * Past seasons below this public `tournamentId` are hidden from history / result modal (legacy).
 * Sync with backend `MIN_PUBLIC_TOURNAMENT_HISTORY_UI_ID`.
 */
export const MIN_PUBLIC_TOURNAMENT_HISTORY_UI_ID = 8

/**
 * Highest placement that earns (and can claim) a season reward.
 * Sync with backend `TOURNAMENT_PLACEMENT_CLAIM_MAX_RANK`.
 */
export const TOURNAMENT_PLACEMENT_CLAIM_MAX_RANK = 100

/**
 * Fallback entry fee in Gems when a tournament payload omits `entryFeeGems`.
 * Sync with backend `DEFAULT_TOURNAMENT_ENTRY_FEE_GEMS`.
 */
export const DEFAULT_TOURNAMENT_ENTRY_FEE_GEMS = 1000

/** Upcoming-tournament cards requested for the hub rail. */
export const TOURNAMENT_UPCOMING_CARD_COUNT = 3
